import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from "react-query";

import {
  createChequePrintTemplate,
  deleteChequePrintTemplate,
  getChequePrintTemplates,
  updateChequePrintTemplate,
} from "./requests";
import {
  ChequePrintTemplate,
  CreateChequePrintTemplateBody,
  UpdateChequePrintTemplateBody,
} from "../types";

export const CHEQUE_PRINT_TEMPLATES_QUERY = "get-cheque-print-templates";

export function useGetChequePrintTemplates(
  params?: { page?: number; pageSize?: number },
  options?: Omit<
    UseQueryOptions<ChequePrintTemplate[], unknown>,
    "queryKey" | "queryFn"
  >
) {
  return useQuery(
    [CHEQUE_PRINT_TEMPLATES_QUERY, params],
    () =>
      getChequePrintTemplates({
        page: params?.page ?? 1,
        pageSize: params?.pageSize ?? 1000,
      }),
    options
  );
}

export function useCreateChequePrintTemplate() {
  const queryClient = useQueryClient();
  return useMutation(
    (body: CreateChequePrintTemplateBody) => createChequePrintTemplate(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [CHEQUE_PRINT_TEMPLATES_QUERY] });
      },
    }
  );
}

export function useUpdateChequePrintTemplate() {
  const queryClient = useQueryClient();
  return useMutation(
    (body: UpdateChequePrintTemplateBody) => updateChequePrintTemplate(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [CHEQUE_PRINT_TEMPLATES_QUERY] });
      },
    }
  );
}

export function useDeleteChequePrintTemplate() {
  const queryClient = useQueryClient();
  return useMutation(
    (printtemplateid: number) => deleteChequePrintTemplate(printtemplateid),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [CHEQUE_PRINT_TEMPLATES_QUERY] });
      },
    }
  );
}
